import { format, subDays } from "date-fns";
import React, { useEffect, useState } from "react";
import { Divider, Header, Popup, Segment, Statistic } from "semantic-ui-react";
import Alerts from "utilities/Alerts";
import http from "utilities/http";

function StockDashboard() {
	const [openingStockValue, setOpeningStockValue] = useState(0);
	const [currentStockValue, setCurrentStockValue] = useState(0);

	useEffect(() => {
		const getOpeningStock = async (startDate, endDate) => {
			try {
				const response = await http.get(
					`/report/inventory/date/${startDate}/${endDate}`
				);

				const { records } = response.data;

				let openingStockVal = 0;
				let currentStockVal = 0;

				for (const rec of records) {
					openingStockVal += parseFloat(rec.openingStock);
					currentStockVal += parseFloat(rec.closingStock);
				}

				setOpeningStockValue(openingStockVal);
				setCurrentStockValue(currentStockVal);
			} catch (ex) {
				Alerts.httpException(ex);
			}
		};

		const today = format(new Date(), "yyyy-MM-dd");
		const tomorrow = format(subDays(new Date(), -1), "yyyy-MM-dd");

		getOpeningStock(today, tomorrow);
	});

	return (
		<Segment textAlign="center" style={{ height: "100%" }}>
			<Header>
				Stock Value Today <br /> (NRS)
			</Header>

			<Divider hidden />
			<Divider hidden />

			<Popup
				inverted
				trigger={
					<Statistic
						size="small"
						label="Current"
						value={currentStockValue}
					/>
				}
				content="Out of cost price."
			/>
			<Divider hidden />
			<Popup
				inverted
				trigger={
					<Statistic
						size="small"
						label="Opening"
						value={openingStockValue}
					/>
				}
				content="Out of cost price."
			/>
			<Divider hidden />
			<Popup
				inverted
				trigger={
					<Statistic
						size="small"
						label="Change"
						value={Math.abs(openingStockValue - currentStockValue)}
					/>
				}
				content="Out of cost price."
			/>
		</Segment>
	);
}

export default StockDashboard;
